import React, { useEffect, useState } from 'react';
import Appearance from 'styles/Appearance.js';
import { formatCountdown } from 'files/LimitedOffer.js';
import { useServiceability } from 'views/ServiceabilityProvider.js';

// Countdown strip drawn at the top of the fixed header while a limited-time
// offer is live (online-sales visitors only — `offer` is null everywhere else).
//
// It publishes its height as the --offer-banner-height CSS variable, which every
// offset below the header adds (see Appearance.layout), so pages shift down
// while it shows and back up when the offer ends.
const LimitedOfferBanner = ({ onClick }) => {

    const { offer } = useServiceability();
    const [now, setNow] = useState(Date.now());
    const height = Appearance.layout.offerBannerHeight();

    useEffect(() => {
        if(!offer) {
            return;
        }
        const timer = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(timer);
    }, [offer]);

    useEffect(() => {
        const root = document.documentElement.style;
        root.setProperty('--offer-banner-height', offer ? `${height}px` : '0px');
        return () => root.setProperty('--offer-banner-height', '0px');
    }, [offer, height]);

    if(!offer) {
        return null;
    }

    return (
        <div
            onClick={onClick}
            style={{
                height: height,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
                padding: '0 16px',
                backgroundColor: Appearance.colors.primary(),
                color: Appearance.colors.white,
                fontFamily: Appearance.fonts.body,
                fontSize: 13,
                fontWeight: 600,
                cursor: onClick ? 'pointer' : 'default',
                whiteSpace: 'nowrap',
            }}>
            <i className={'fas fa-bolt'} style={{ fontSize: 11 }} />
            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}>
                {offer.title}
            </span>
            <span style={{ opacity: 0.85, fontWeight: 500, flexShrink: 0 }}>
                {'Ends in'}
            </span>
            <span style={{ fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>
                {formatCountdown(offer.endsAt, now)}
            </span>
        </div>
    );
};

export default LimitedOfferBanner;
